import { defineStore } from 'pinia'
import { i18n } from '@/core/config/i18n.installer.js'
import { fetchCompanyUsers } from '../services/http/company/tenant-admin-company-users.service.js'

export const useTenantAdminUsersStore = defineStore('tenant-admin-users', {
  state: () => ({
    usersList: [],
  }),
  getters: {
    getUsersList: state => state.usersList,
    getUsersForSelect(state) {
      return [
        this.getUndefinedOption,
        ...state.usersList.map(user => ({
          label: user.fullName,
          initials: user.initials,
          value: user.id || user._id,
        })),
      ]
    },
    getUndefinedOption: () => ({
      label: i18n.global.t('tenant-admin.users.undefinedOption.label'),
      initials: i18n.global.t('tenant-admin.users.undefinedOption.initials'),
      value: null,
    }),
  },
  actions: {
    async loadCompanyUsers(companyId) {
      this.usersList = await fetchCompanyUsers(companyId, 'lastLogin:asc')
    },

    setUsersList(users) {
      this.usersList = users
    },
  },
})
